window.Products.Clothing = {

};
window.Products.Clothing.Clothing = function() {
	
};
window.Products.Clothing.Clothing.inherits(window.Products.Product);

window.Products.Clothing.Clothing.dpi = 150;